import React, { useRef } from 'react';
export function VideoTestimonials() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -320 : 320,
        behavior: 'smooth'
      });
    }
  };
  // Only 2 videos as requested
  const videos = [{
    name: 'Silvia R.',
    location: 'Buenos Aires',
    videoUrl: 'https://cdn.magicpatterns.com/uploads/5otWejpYsTGvD9XUpv8TpQ/IMG_8522.MOV'
  }, {
    name: 'Graciela M.',
    location: 'Córdoba',
    videoUrl: 'https://cdn.magicpatterns.com/uploads/nGcQdUAwXen7EmzRLBWVNB/IMG_8523.MOV'
  }];
  return <div className="bg-brand-ink py-16 px-6" data-id="element-329">
      <div className="max-w-[960px] mx-auto" data-id="element-330">
        <span className="block text-[11px] font-bold tracking-[3px] uppercase text-brand-green text-center mb-2.5" data-id="element-331">
          🎥 Escuchá directo de quienes vivieron la transformación
        </span>
        <h2 className="font-display text-[22px] sm:text-[3.5vw] md:text-[38px] text-center text-white mb-2 uppercase" data-id="element-332">
          Dale play y mirá lo que dicen
        </h2>
        <div className="green-divider" data-id="element-333"></div>

        <div className="relative" data-id="element-334">
          <div ref={scrollRef} className="flex gap-5 overflow-x-auto pb-3 scroll-smooth scrollbar-thin scrollbar-thumb-brand-green scrollbar-track-[#222] justify-center md:justify-start" style={{
          scrollbarWidth: 'thin',
          scrollbarColor: '#00c853 #222'
        }} data-id="element-335">
            {videos.map((video, i) => <div key={i} className="flex-none w-[300px] bg-[#1a1a1a] border border-brand-border rounded-xl overflow-hidden" data-id="element-336">
                <div className="h-[400px] bg-[#111] relative" data-id="element-337">
                  <video src={video.videoUrl} className="w-full h-full object-cover" controls playsInline preload="metadata" data-id="element-338" />
                </div>
                <div className="py-3.5 px-4" data-id="element-339">
                  <p className="font-display text-[15px] text-white mb-0.5 uppercase" data-id="element-340">
                    {video.name}
                  </p>
                  <p className="text-[12px] text-brand-muted" data-id="element-341">
                    📍 {video.location}
                  </p>
                </div>
              </div>)}
          </div>

          {/* Only show navigation if there are more videos than fit on screen, but with 2 videos it usually fits on desktop. Kept for mobile. */}
          <div className="flex justify-center gap-3 mt-4 md:hidden" data-id="element-342">
            <button onClick={() => scroll('left')} className="bg-white/5 border border-white/15 text-white w-9 h-9 rounded-full flex items-center justify-center text-lg hover:bg-brand-green/40 transition-colors" data-id="element-343">
              &#8249;
            </button>
            <button onClick={() => scroll('right')} className="bg-white/5 border border-white/15 text-white w-9 h-9 rounded-full flex items-center justify-center text-lg hover:bg-brand-green/40 transition-colors" data-id="element-344">
              &#8250;
            </button>
          </div>
        </div>
      </div>
    </div>;
}